/**
 * Icon mapper utilities for Marpol Regulations and other product classifications
 */

/**
 * Maps Marpol Regulation codes to their corresponding icon paths
 * @param marpolRegulation - The Marpol regulation code (1-4)
 * @returns The path to the appropriate icon
 */
export const marpolRegulationToIconMapper = (marpolRegulation: number): string => {
    switch (marpolRegulation) {
        case 1:
            return '/assets/images/AnnexI.png';
        case 2:
            return '/assets/images/AnnexII.png';
        case 3:
            return '/assets/images/AnnexII.png';
        case 4:
            return '/assets/images/Gas.png';
        default:
            return '/assets/images/NonCargo.png';
    }
};

/**
 * Maps IMDG Code Class to their corresponding icon paths
 * @param imdgCodeClass - The IMDG code class string
 * @returns The path to the appropriate hazard class icon
 */
export const imdgCodeClassToIconMapper = (imdgCodeClass: string): string => {
    if (!imdgCodeClass || imdgCodeClass.length === 0) {
        return '';
    }

    switch (imdgCodeClass[0]) {
        case '1':
            return '/assets/images/HazardClass1.gif';
        case '2':
            return '/assets/images/HazardClass2.gif';
        case '3':
            return '/assets/images/HazardClass3.gif';
        case '4':
            return '/assets/images/HazardClass4.gif';
        case '5':
            return '/assets/images/HazardClass52.gif';
        case '6':
            return '/assets/images/HazardClass6.gif';
        case '7':
            return '/assets/images/HazardClass7.gif';
        case '8':
            return '/assets/images/HazardClass8.gif';
        case '9':
            return '/assets/images/HazardClass9.gif';
        default:
            return '';
    }
};

/**
 * Maps Marpol Regulation codes to FontAwesome icon names and colors
 * @param marpolRegulation - The Marpol regulation code (1-4)
 * @returns An object with the FontAwesome icon name and color
 */
export const marpolRegulationToFAIcon = (marpolRegulation: number): { icon: string; color: string } => {
    switch (marpolRegulation) {
        case 1: // Annex I (oil)
            return { icon: 'droplet', color: '#1a1a1a' };
        case 2: // Annex II Ch17 (chemicals)
            return { icon: 'flask', color: '#1a1a1a' };
        case 3: // Annex II Ch18 (chemicals)
            return { icon: 'flask', color: '#1a1a1a' };
        case 4: // Gas
            return { icon: 'gas-pump', color: '#1a1a1a' };
        default: // Non-cargo
            return { icon: 'droplet', color: '#bbb' };
    }
};

/**
 * Gets the alt text for Marpol Regulation icons
 * @param marpolRegulation - The Marpol regulation code
 * @returns Descriptive alt text for the icon
 */
export const getMarpolRegulationAltText = (marpolRegulation: number): string => {
    switch (marpolRegulation) {
        case 1:
            return 'Marpol Annex I - Oil';
        case 2:
            return 'Marpol Annex II - Noxious Liquid Substances (Chapter 17)';
        case 3:
            return 'Marpol Annex II - Noxious Liquid Substances (Chapter 18)';
        case 4:
            return 'Gas Cargo';
        default:
            return 'Non-Cargo';
    }
};